module.exports = __webpack_public_path__ + "media/images/logo-a6a6153fc5535464feafc1751731676e.svg";